module.exports = __webpack_public_path__ + "img/capsule-2@2x.0266140b.webp";